import { createAsyncThunk } from '@reduxjs/toolkit';
import { ActiveService } from '../../epics/common/active';
import {
    getActiveCheckautoListKey,
    getActivePartsListKey,
    getActivePlacementListKey,
    getActiveRentListKey,
    getActiveSellListKey,
    getActiveServicesListKey,
} from '../active/activeKeys';

export const getActiveCheckautoList = createAsyncThunk(
    getActiveCheckautoListKey,
    async (_, thunkAPI) => {
        try {
            const response = await ActiveService.getActiveCheckautoList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getActivePartsList = createAsyncThunk(
    getActivePartsListKey,
    async (_, thunkAPI) => {
        try {
            const response = await ActiveService.getActivePartsList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getActivePlacementList = createAsyncThunk(
    getActivePlacementListKey,
    async (_, thunkAPI) => {
        try {
            const response = await ActiveService.getActivePlacementList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getActiveRentList = createAsyncThunk(
    getActiveRentListKey,
    async (_, thunkAPI) => {
        try {
            const response = await ActiveService.getActiveRentList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getActiveSellList = createAsyncThunk(
    getActiveSellListKey,
    async (_, thunkAPI) => {
        try {
            const response = await ActiveService.getActiveSellList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getActiveServicesList = createAsyncThunk(
    getActiveServicesListKey,
    async (_, thunkAPI) => {
        try {
            const response = await ActiveService.getActiveServicesList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);
